module.exports = __webpack_public_path__ + "promotions.svg?b891f5ae9054296d345cadbe7a743619";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotions.svg
// module id = 96
// module chunks = 2